import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tabs - A wrapper that renders a standard HTML div with Bulma tabs class names
 * 
 * This component accepts the same props as Bloomer Tabs for easy migration
 */
const Tabs = ({
  className,
  style,
  isAlign,
  isSize,
  isBoxed,
  isToggle,
  isToggleRounded,
  isFullWidth,
  children,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['tabs'];
    
    // Add appropriate classes based on props
    if (isAlign) {
      classes.push(`is-${isAlign}`);
    }
    
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    if (isBoxed) {
      classes.push('is-boxed');
    }
    
    if (isToggle) {
      classes.push('is-toggle');
    }
    
    if (isToggleRounded) {
      classes.push('is-toggle-rounded');
    }
    
    if (isFullWidth) {
      classes.push('is-fullwidth');
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <div 
      className={getClassNames()} 
      style={style}
      {...props}
    >
      {children}
    </div>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  isAlign: PropTypes.oneOf(['centered', 'right']),
  isSize: PropTypes.oneOf(['small', 'medium', 'large']),
  isBoxed: PropTypes.bool,
  isToggle: PropTypes.bool,
  isToggleRounded: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  children: PropTypes.node
};

Tabs.defaultProps = {
  className: '',
  style: {},
  isAlign: null,
  isSize: null,
  isBoxed: false,
  isToggle: false,
  isToggleRounded: false,
  isFullWidth: false,
  children: null
};

export default Tabs;
